import { render, staticRenderFns } from "./Dobargain.vue?vue&type=template&id=2dce0162&scoped=true"
import script from "./Dobargain.vue?vue&type=script&lang=js"
export * from "./Dobargain.vue?vue&type=script&lang=js"
import style0 from "./Dobargain.vue?vue&type=style&index=0&id=2dce0162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dce0162",
  null
  
)

export default component.exports